import { Co2MaterialLibrary, MaterialLibrariesClient } from "@api/apiClient";
import axios from "@api/axiosInstance";
import { useQuery } from "@tanstack/react-query";

const materialLibrariesClient = new MaterialLibrariesClient(undefined, axios);

export const useCo2MaterialLibraries = (options?: any) => {
  return useQuery<Co2MaterialLibrary[]>({
    ...options,
    queryKey: ["materialLibraries"],
    queryFn: async () => materialLibrariesClient.getMaterialLibraries(),
    placeholderData: [],
    staleTime: 30 * 60 * 1000, // 30 minutes
    cacheTime: 60 * 60 * 1000, // 60 minutes      
  });
};
